import { useEffect } from "react";
import "../Snackbar/Snackbar.css";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const Snackbar = ({ messages, status, setStatus, snackbarRef }) => {
  useEffect(() => {
    if (status) {
      setTimeout(() => {
        setStatus(false);
      }, 3000);
    }
  }, [setStatus, status]);
  return (
    <div
      className="snackbar"
      id={status ? "show" : "hide"}
      style={{
        backgroundColor: snackbarRef === "success" ? "#00F593" : "#FF0033",
      }}
    >
      <div className="symbol">
        {snackbarRef === "success" ? (
          <h1>
            <CheckIcon />
          </h1>
        ) : (
          <h1>
            <CloseIcon sx={{ color: "white" }} />
          </h1>
        )}
      </div>
      <div className="messages">{messages}</div>
    </div>
  );
};

export default Snackbar;
